<template>
  <div>
    <div class="content-head">
      <div>
        <h2>污染物浓度地图</h2>
      </div>

      <div style="text-align: left">
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >什么是气象调整方法？<i class="header-icon el-icon-info"></i
              ></span>
            </template>
            <div>
              基于2011年3月到2019年2月累积八年的小时气象数据，对“2+66”城市分别构造基准气象条件，在此基准气象条件下计算各季节污染物的浓度，通过控制气象条件，捕捉潜在排放量的变化。具体来说，我们采用核估计方法，对各年份和季度的污染与气象数据建立调整模型，将该模型作用于八年基准气象的经验分布函数，计算调整均值。
            </div>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >污染物浓度分级标准<i class="header-icon el-icon-info"></i
              ></span>
            </template>
            <div>
              <div>下面给出《环境空气质量标准》给定的污染物年均浓度等级</div>
              <el-table :data="tableData2" border style="width: 100%">
                <el-table-column prop="level" label="年均浓度污染等级">
                </el-table-column>
                <el-table-column prop="pm2_5">
                  <template slot="header" slot-scope="scope">
                    PM2.5(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="PM10" label="PM10">
                  <template slot="header" slot-scope="scope">
                    PM10(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="pm10_2_5" label="PM10-2.5">
                  <template slot="header" slot-scope="scope">
                    PM10-2.5(ug/m<sup>3</sup>)
                  </template>
                </el-table-column> -->
                <el-table-column prop="SO2" label="SO2">
                  <template slot="header" slot-scope="scope">
                    SO2(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="CO" label="CO">
                  <template slot="header" slot-scope="scope">
                    CO(mg/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="NO2" label="NO2">
                  <template slot="header" slot-scope="scope">
                    NO2(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="O3" label="O3">
                  <template slot="header" slot-scope="scope">
                    O3(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
              </el-table>

              <div style="margin-top: 20px">下面给出污染物浓度日均标准</div>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="level" label="日均浓度污染等级">
                </el-table-column>
                <el-table-column prop="pm2_5">
                  <template slot="header" slot-scope="scope">
                    PM2.5(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="PM10" label="PM10">
                  <template slot="header" slot-scope="scope">
                    PM10(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="pm10_2_5" label="PM10-2.5">
                  <template slot="header" slot-scope="scope">
                    PM10-2.5(ug/m<sup>3</sup>)
                  </template>
                </el-table-column> -->
                <el-table-column prop="SO2" label="SO2">
                  <template slot="header" slot-scope="scope">
                    SO2(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="CO" label="CO">
                  <template slot="header" slot-scope="scope">
                    CO(mg/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="NO2" label="NO2">
                  <template slot="header" slot-scope="scope">
                    NO2(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="O3" label="O3">
                  <template slot="header" slot-scope="scope">
                    O3(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div style="text-align: left; margin-top: 15px" class="options-selector">
        <el-row>
          污染物：
          <el-radio-group v-model="assessPull" @change="pullChange">
            <el-radio label="PM2.5">PM2.5</el-radio>
            <el-radio label="PM10">PM10</el-radio>
            <el-radio label="SO2">SO2</el-radio>
            <el-radio label="NO2">NO2</el-radio>
            <el-radio label="CO">CO</el-radio>
            <el-radio label="O3">O3</el-radio>
          </el-radio-group>
        </el-row>

        <el-row>
          评估年份：
          <!-- <el-date-picker
            v-model="assessYear"
            type="year"
            placeholder="选择评估年份"
            :picker-options="pickerOptions"
            @change="assessYearChange"
            size="mini"
          ></el-date-picker> -->

          <el-select
            size="mini"
            v-model="assessYear"
            placeholder="请选择"
            @change="assessYearChange"
          >
            <el-option
              v-for="item in Years"
              :key="item"
              :label="item + '年'"
              :value="item"
            ></el-option>
          </el-select>

          <el-select
            size="mini"
            v-model="assessSeason"
            placeholder="请选择"
            @change="assessSeasonChange"
          >
            <el-option
              v-for="item in Seasons"
              :key="item.name"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-row>

        <el-row>
          显示数据：
          <el-radio-group
            v-model="assessPullContent"
            @change="assessPullContentChange"
          >
            <el-radio label="raw">气象调整前</el-radio>
            <el-radio label="data">气象调整后</el-radio>
          </el-radio-group>
        </el-row>
      </div>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button
          type="success"
          icon="el-icon-download"
          @click="downloadImage"
          :loading="imageDownloading"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div class="content-body" style="margin-top: 30px" id="area-pull-chart-map">
      <el-row>
        <el-col :sm="24" :md="14">
          <div
            class="area-pull"
            id="area-pull-chart"
            :style="{ height: eleheight + 'px', paddingRight: '1px' }"
          ></div>
        </el-col>
        <el-col :sm="24" :md="10">
          <div id="area-pull-map" :style="{ height: eleheight + 'px' }"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style scoped>
/* .el-button {
  border-width: 0px;
  color: black;
  padding: 0 10px;
  margin: 0;
  background: transparent;
} */

.el-row {
  margin-bottom: 15px;
}
.el-divider {
  margin: 0;
  margin-bottom: 10px;
}
</style>

<script>
// import { drawAreaPullRankChart } from "@/assets/js/areaPullRankChart.js";
import {
  getPullStand,
  debounce,
  pull_level_array,
} from "@/assets/js/my-utils.js";
import { getRGBColor, GenerateMapImgFromDom } from "@/assets/js/utils-map.js";

export default {
  name: "Platform",
  data() {
    return {
      chart: [],
      map: "",
      disProvince: "",
      marker: "",
      pulldata: [],
      mapeventadd: false,
      // cityname: ["北京"],
      eleheight: 520,
      assessYear: "2023",
      assessSeason: 1,
      assessPull: "PM2.5",
      assessPullContent: "data",
      Years: [
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
        "2013",
      ],
      Seasons: [
        {
          name: "春季",
          value: 1,
        },
        {
          name: "夏季",
          value: 2,
        },
        {
          name: "秋季",
          value: 3,
        },
        {
          name: "冬季",
          value: 4,
        },
        {
          name: "年均",
          value: 0,
        },
      ],

      tableData2: [
        {
          level: "一级",
          pm2_5: "15",
          PM10: "40",
          SO2: "20",
          NO2: "40",
          CO: "4",
          O3: "100(8小时平均)",
        },
        {
          level: "二级",
          pm2_5: "35",
          PM10: "70",
          SO2: "60",
          NO2: "40",
          CO: "4",
          O3: "160(8小时平均)",
        },
      ],
      tableData: [
        {
          level: "优",
          pm2_5: "≤35",
          PM10: "≤50",
          // pm10_2_5: "≤50",
          SO2: "≤50",
          CO: "≤2",
          NO2: "≤40",
          O3: "≤100",
        },
        {
          level: "良",
          pm2_5: "≤75",
          PM10: "≤150",
          SO2: "≤150",
          CO: "≤4",
          NO2: "≤80",
          O3: "≤160",
        },
        {
          level: "轻度污染",
          pm2_5: "≤115",
          PM10: "≤250",
          SO2: "≤475",
          CO: "≤14",
          NO2: "≤180",
          O3: "≤215",
        },
        {
          level: "中度污染",
          pm2_5: "≤150",
          PM10: "≤350",
          SO2: "≤800",
          CO: "≤24",
          NO2: "≤280",
          O3: "≤265",
        },
        {
          level: "重度污染",
          pm2_5: "≤250",
          PM10: "≤420",
          SO2: "≤1600",
          CO: "≤36",
          NO2: "≤565",
          O3: "≤800",
        },
        {
          level: "严重污染",
          pm2_5: ">250",
          PM10: ">420",
          SO2: ">1600",
          CO: ">36",
          NO2: ">565",
          O3: ">800",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > 2021 || time.getFullYear() < 2013;
        },
      },
      mapcenter: [113.828577, 36.4],
      imageDownloading: false,
    };
  },
  computed: {},
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    downloadImage() {
      let imageDom = document.getElementById("area-pull-chart-map");

      let title;

      let pull = this.assessPull;
      let seasonZh = ["全年平均", "春季", "夏季", "秋季", "冬季"];
      let time = this.assessYear + "年" + seasonZh[this.assessSeason];
      let content = this.assessPullContent;

      if (content == "raw") {
        title = time + "各城市" + pull + "原始浓度及排名";
      } else {
        title = time + "各城市" + pull + "经气象调整后浓度及排名";
      }
      if (time.indexOf("全年平均") != -1) {
        if (content == "raw") {
          title =
            time.replace("全年平均", "") +
            "各城市" +
            pull +
            "年平均原始浓度及排名";
        } else {
          title =
            time.replace("全年平均", "") +
            "各城市" +
            pull +
            "经气象调整后年平均浓度及排名";
        }
      }
      GenerateMapImgFromDom(imageDom, title + ".png");
    },
    assessYearChange() {
      // this.assessYear = this.assessYear.getFullYear() + "";
      // alert(this.assessYear);
      this.updateCharts();
    },
    assessSeasonChange() {
      this.updateCharts();
    },
    pullChange() {
      this.updateCharts();
    },
    assessPullContentChange() {
      this.updateCharts();
    },
    drawAreaPullRankChart(chart, data, time, pull, content = "data") {
      let rank_data = [];
      let value_data = [];

      // 对value 排序
      if (content == "raw") {
        data.sort((a, b) => {
          return parseFloat(a[1]) - parseFloat(b[1]);
        });
      } else {
        data.sort((a, b) => {
          return parseFloat(a[2]) - parseFloat(b[2]);
        });
      }

      // console.log("AAAAAAAAAAAA");
      // console.log(data);

      data.forEach((item, idx) => {
        // // 浓度，城市，排名

        if (content == "raw") {
          rank_data.push([item[0], item[3]]);
          value_data.push([item[0], parseFloat(item[1]).toFixed(2)]);
        } else {
          rank_data.push([item[0], item[4]]);
          value_data.push([item[0], parseFloat(item[2]).toFixed(2)]);
        }
      });

      let title;

      if (content == "raw") {
        title = time + "各城市" + pull + "原始浓度及排名";
      } else {
        title = time + "各城市" + pull + "经气象调整后浓度及排名";
      }
      if (time.indexOf("全年平均") != -1) {
        if (content == "raw") {
          title =
            time.replace("全年平均", "") +
            "各城市" +
            pull +
            "年平均原始浓度及排名";
        } else {
          title =
            time.replace("全年平均", "") +
            "各城市" +
            pull +
            "经气象调整后年平均浓度及排名";
        }
      }

      let visualMapTop = 0;

      let city_colors = [];

      let stds = pull_level_array()[pull];
      // alert(stds);

      let title_x = title;

      let that = this;

      let option = {
        title: {
          text: title,
          left: "10",
          align: "right",
        },
        grid: {
          bottom: 45,
          left: 10,
          right: 85,
          containLabel: true,
        },

        toolbox: {
          show: true,
          feature: {
            // dataZoom: {
            //   yAxisIndex: "none",
            // },
            // dataView: { readOnly: false },
            // magicType: { type: ["line", "bar"] },
            // restore: {},
            // mySaveAsImage: {
            //   show: true,
            //   pixelRatio: 2,
            //   icon: "path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891",
            //   title: "保存浓度及排名曲线",
            //   onclick: function () {
            //     alert("myToolHandler1");
            //     // 1. 下载地图文件
            //   },
            // },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            animation: false,
            label: {
              // backgroundColor: "#505765",
            },
          },

          formatter: function (params) {
            let text = params[0].axisValue + "<br>";
            params.forEach((element) => {
              if (element.seriesType == "bar") {
                text +=
                  element.marker +
                  pull +
                  ": " +
                  element.value[1] +
                  getPullStand(pull) +
                  " <br>";
              } else {
                text +=
                  element.marker +
                  pull +
                  "浓度排名: " +
                  element.value[1] +
                  "<br>";
              }
            });
            return text;
          },
        },
        legend: {
          right: 100,
        },
        visualMap: [
          {
            type: "piecewise",
            show: true,
            bottom: 60,
            right: "right",

            // top: 30,
            // right: "center",
            // orient: "horizontal",
            pieces: [
              {
                gt: 0,
                lte: stds[0],
                label: "<" + stds[0],
                color: "#00E400",
              },
              {
                gt: stds[0],
                lte: stds[1],
                label: "<" + stds[1],
                color: "#FFDC00",
              },
              {
                gt: stds[1],
                lte: stds[2],
                label: "<" + stds[2],
                color: "#FFB03B",
              },
              {
                gt: stds[2],
                lte: stds[3],
                label: "<" + stds[3],
                color: "#FF7E00",
              },
              {
                gt: stds[3],
                lte: stds[4],
                label: "<" + stds[4],
                color: "#FF5B5B",
              },
              {
                gt: stds[4],
                lte: stds[5],
                label: "<" + stds[5],
                color: "#FF0000",
              },
              {
                gt: stds[5],
                lte: stds[6],
                label: "<" + stds[6],
                color: "#99004C",
              },
              {
                gt: stds[6],
                lte: stds[7],
                label: "<" + stds[7],
                color: "#7E0023",
              },
              {
                gt: stds[7],
                // lte: stds[8],
                label: ">" + stds[7],
                color: "#000000",
              },
            ],
            dimension: 1,
            seriesIndex: 0,
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            right: 110,
            startValue: 0,
            endValue: 20,
          },
        ],
        xAxis: [
          {
            type: "category",
            axisLine: { onZero: false },
          },
        ],
        yAxis: [
          {
            name: getPullStand(pull),
            type: "value",
          },
          {
            name: "排名",
            type: "value",
          },
        ],
        series: [
          {
            name: "浓度",
            type: "bar",
            animation: false,
            areaStyle: {},
            lineStyle: {
              width: 1,
            },

            label: {
              show: true,
              formatter: function (parma) {
                // console.log(parma);
                city_colors.push({
                  city: parma.name,
                  color: parma.color,
                });
                return "";
              },
              color: "#F56C6C",
              position: "top",
            },

            data: value_data,

            // animation: false,
          },
          {
            name: "排名曲线",
            type: "line",
            yAxisIndex: 1,
            animation: true,
            animationDuration: 2500,
            // areaStyle: {},
            lineStyle: {
              width: 1,
              // type: "dashed",
            },
            data: rank_data,

            // animation: true,
          },
        ],
      };

      chart.setOption(option, {
        notMerge: true,
      });
      chart.resize();
      chart.hideLoading();
    },

    getPullMapsData() {
      const that = this;

      let url = "/AQAssess/getPullMap/" + this.assessPull + "/" + this.assessYear + "/" + this.assessSeason;
      this.$axios
        .get(url)
        .then((res) => {
          if (res.data.length < 1) {
            this.$message({
              type: "info",
              message: "当前季度没有数据",
            });
          } else {
            // 添加调整后的排名
            let data = res.data;
            data = data.sort((a, b) => {
              return parseFloat(a[2]) - parseFloat(b[2]);
            });

            for (let rank = 1; rank <= data.length; rank++) {
              data[rank - 1].push(rank);
            }

            let pulldata = [];
            data.forEach((element) => {
              for (let i = 0; i < that.assesscity.length; i++) {
                if (element[0] == that.assesscity[i][1]) {
                  pulldata.push(element);
                  break;
                }
              }
            });

            let seasonZh = ["全年平均", "春季", "夏季", "秋季", "冬季"];
            this.drawAreaPullRankChart(
              this.chart[0],
              pulldata,
              that.assessYear + "年" + seasonZh[that.assessSeason],
              that.assessPull,
              that.assessPullContent
            );

            this.drawAreaMapOverlays(
              pulldata,
              that.assessPull,
              that.assessPullContent
            );

            that.pulldata = pulldata;
          }
        });
      // .catch((e) => {
      //   this.$message({
      //     type: "info",
      //     message: "获取数据失败",
      //   });
      // });
    },

    drawAreaMapOverlays(pulldata, pull, content = "raw") {
      // 1. 创建城市和颜色对应表

      let aCity = [];
      let aColor = [];

      pulldata.forEach((item, idx) => {
        let city = item[0];

        let city_color;
        if (city) {
          // aCity.push(city + "市");

          // 部分添加城市
          if( item[0].indexOf("盟") == -1){
            aCity.push(city + "市");
          }else{
            aCity.push(city);
          }
          

          if (content == "raw") {
            city_color = getRGBColor(parseFloat(item[1]), "pull", pull);
          } else {
            city_color = getRGBColor(parseFloat(item[2]), "pull", pull);
          }

          aColor.push(city_color);
        }
      });


      // 2.绘制
      // dep = 1 表示市级
      let depth = 1;
      var disProvince;
      var that = this;
      // 清理图层
      if (this.disProvince) {
        this.map.remove(this.disProvince);
      }

      this.disProvince && this.disProvince.setMap(null);

      this.disProvince = new AMap.DistrictLayer.Province({
        zIndex: 12,
        
        adcode: [
          110000, // 北京
          120000, // 天津市
          130000, // 河北省
          140000, // 山西省
          150000, // 内蒙古自治区
          310000, // 上海市
          320000, // 江苏省
          340000, // 安徽省
          360000, // 江西省
          370000, // 山东省
          410000, // 河南省
          610000, // 陕西省
          330000, // 浙江
        ],
        depth: depth,
        opacity: 0.8,
        styles: {
          fill: function (properties) {
            // properties为可用于做样式映射的字段，包含
            // NAME_CHN:中文名称
            // adcode_pro
            // adcode_cit
            // adcode
            let adcode_pro = properties.adcode_pro;

            let NAME_CHN = properties.NAME_CHN;

            let colorIDX = aCity.indexOf(NAME_CHN);
            if (colorIDX != -1) {
              return aColor[colorIDX];
            }

            return "";
          },
          "province-stroke": "cornflowerblue",
          "city-stroke": "white", // 中国地级市边界
          "county-stroke": "rgba(255,255,255,0.5)", // 中国区县边界
        },
      });

      this.disProvince.setMap(this.map);
    },

    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getPullMapsData();
    },
  },
  created() {},
  mounted() {
    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("area-pull-chart"))
      );

      // this.map = initBaiduMapCharts("area-pull-map", true, this.mapcenter);

      this.map = new AMap.Map("area-pull-map", {
        zoom: 5,
        center: [113, 34.5],
        pitch: 0,
        viewMode: "3D",
      });

      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.updateCharts();
    }

    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
  watch: {
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;
      if (this.show) {
        this.updateCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];
        this.chart.push(
          this.$echarts.init(document.getElementById("area-pull-chart"))
        );

        this.map = new AMap.Map("area-pull-map", {
          zoom: 5,
          center: [113, 34.5],
          pitch: 0,
          viewMode: "3D",
          WebGLParams: {
            preserveDrawingBuffer: true,
          },
        });

        this.chart.forEach((element) => {
          element.showLoading();
        });

        this.updateCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
};
</script>



